import React, {memo} from "react";
import { withStyles, withTheme } from "@material-ui/core";
import styles from "./styles";
import StyledToolTip from "../../../components/common/StyledToolTip";
import EndTripIcon from "../../icons/EndTripIcon";
import { compose } from "recompose";

class EndTrip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      enable: false,
    };
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updateEndTripIconStatus`,
      this.changeEndTripStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updateEndTripIconStatus`,
      this.changeEndTripStatus
    );
  }

  changeEndTripStatus = (enable) => {
    if (this.state.enable !== enable) {
      this.setState({
        enable,
      });
    }
  };

  onShowEndTrip = () => {
    if (this.state.enable) {
      this.props.eventHub.emit("onShowEndTrip");
    }
  };

  render() {
    const { classes,theme } = this.props;
    return (
      <div
        className={`${classes.headerIconStyles} ${
          classes.iconLayout
        } glHeaderIcons ${
          this.state.enable ? classes.enabledDangerIcon : classes.disableIcon
        }`}
        onClick={this.onShowEndTrip}
      >
        <StyledToolTip title="End Trip">
          <div className="end-trip-icon-wrapper">
            <EndTripIcon color={this.state.enable ? theme.endTripIconActive : theme.iconColor } />
          </div>
        </StyledToolTip>
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withTheme(),
)(memo(EndTrip));
